<template>
  <div class="custom-container" v-loading.fullscreen.lock="pushcartProduct.isLoading">
    <el-row>
      <el-row type="flex" align="center" class="my-4" justify="space-between">
        <el-col :span="5">
          <div class="category-title">Create Pushcart Product</div>
        </el-col>
        <el-col :span="4">
          <el-row type="flex" justify="end">
            <el-button size="small" @click="$router.go(-1)">Kembali</el-button>
            <el-button size="small" type="primary" @click="save">Simpan</el-button>
          </el-row>
        </el-col>
      </el-row>

      <el-col :span="24">
        <el-form
          label-position="top"
          ref="pushcartProduct"
          :model="pushcartProduct"
          class="form-pushcart-product"
        >
          <Form :PushcartProduct="pushcartProductForm"></Form>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Form from "./Form";
import { mapActions, mapState } from "vuex";
export default {
  components: {
    Form
  },
  data: () => ({
    pushcartProductForm: {
      type: "",
      packingType: "",
      upsellingName: "",
      upsellingProduct: "",
      realPrice: 0,
      salePrice: 0,
      productQty: 0,
      discountType: "",
      discountPrice: 0,
      maxDiscountPrice: 0,
      image: "",
    },
    valid: true,
    draft: false
  }),
  computed: {
    ...mapState({
      pushcartProduct: state => state.pushcartProduct.pushcartProduct
    })
  },
  methods: {
    ...mapActions({
      createPushcartProduct: "pushcartProduct/CreatePushcartProduct"
    }),
    save() {
      this.$refs.pushcartProduct.validate(valid => {
        if (valid) {
          this.createPushcartProduct(this.pushcartProduct);
          this.snackbar = true;
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style>
.form-pushcart-product .el-form-item__label {
  padding: 0 !important;
}
.form-pushcart-product .el-upload--text {
  width: 100% !important;
}
.form-pushcart-product .el-upload-dragger {
  width: 100% !important;
}
</style>
